(() => {
/* Wild Gainz discount code chip (snippets/wildgainz-copy-code.liquid).
   Progressive enhancement: the copy button ships hidden. It appears only
   when the clipboard API exists, so on a plain HTTP preview or an old
   browser the chip is just the auto-apply link. A tap copies the code and
   the button reads the copied label for two seconds. */

if (customElements.get('wildgainz-copy-code')) return;

class WildgainzCopyCode extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.button = this.querySelector('[data-copy]');
    this.status = this.querySelector('[data-status]');
    if (!this.button || !navigator.clipboard || !window.isSecureContext) return;

    this.label = this.button.textContent;
    this.button.hidden = false;
    this.button.addEventListener('click', () => this.copy());
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.dataset.code || '');
    } catch (error) {
      return;
    }
    const copied = this.dataset.copiedLabel || this.label;
    this.button.textContent = copied;
    this.classList.add('is-copied');
    if (this.status) this.status.textContent = copied;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.button.textContent = this.label;
      this.classList.remove('is-copied');
    }, 2000);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }
}

customElements.define('wildgainz-copy-code', WildgainzCopyCode);
})();
